import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  Divider,
  Input,
  Typography,
  Table,
  Skeleton,
  Result
  //   Space
} from 'antd';
import {
  SearchOutlined,
} from '@ant-design/icons';
import { formatPhone } from '../../utils/customFunctions';
import CreateButton from '../../components/CreateButton';
import { useQuery } from '@tanstack/react-query';

const columns = [
  {
    title: 'ชื่อ',
    dataIndex: 'fname',
    key: 'fname',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/customers/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'นามสกุล',
    dataIndex: 'lname',
    key: 'lname',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/customers/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'เบอร์โทร',
    dataIndex: 'phone',
    key: 'phone',
    width: '60%',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/customers/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {formatPhone(text)}
      </Button>
  },
  // {
  //   title: 'อีเมล์',
  //   dataIndex: 'email',
  //   key: 'email',
  //   render: (text, record) =>
  //     <Button
  //       type='text'
  //       href={`/admin/customers/edit/${record._id}`}
  //       style={{
  //         width: "100%",
  //         background: 'none',
  //         textAlign: 'left'
  //       }}>
  //       {text}
  //     </Button>
  // },
]


function List() {

  const [filterData, setFilterData] = useState(null);
  const { isLoading, isError, error, data } = useQuery({ queryKey: ['/api/customer/'] })

  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.fname.includes(s) || f.lname.includes(s) || f.phone.includes(s))
    setFilterData(target);
  }
  // console.log(data);
  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการลูกค้า
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <CreateButton linkTo='/admin/customers/create' />
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="ค้นหา" prefix={<SearchOutlined />} onChange={onSearch} />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={filterData || data}
                scroll={{
                  x: 1200,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List